import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { DatatableComponent, ColumnMode } from "@swimlane/ngx-datatable";
import { ApiService } from "app/shared/services/api.service";
import { environment } from "environments/environment";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import swal from 'sweetalert2';
import { DynamicDetailComponent } from "../../dynamic-detail/dynamic-detail.component";
import { Subscription } from "rxjs";
import { Store } from "@ngrx/store";
import { AppState } from "app/App Store/state";
import { setPageNumber } from "app/App Store/actions/pageChange.actions";

@Component({
  selector: 'app-all-users-list',
  templateUrl:'./all-users-list.component.html',
  styleUrls: ['./all-users-list.component.scss',
    "../../../../../../assets/sass/libs/datatables.scss",],
encapsulation: ViewEncapsulation.None,
})
export class AllUsersListComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 20,
    totalPages:0
  };
  searchByName=''
  isActivated:boolean
  // row data

  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 20;
  selectedValue='';
  isFilter:boolean=false
  // column header
  public columns = [
    { name: "Name", prop: "name" },
    { name: "Contact", prop: "phone" },
    { name: "Email", prop: "email" },
    { name: "Role", prop: "roles" },
    {name:"Activated/Deactivated",prop:"is_activated"},
    { name: "Actions", prop: "Actions" },
  ];
  myDrop1: any;
  userId:any

  // private
  private tempData = [];
  roles=[];
  imageUrl=environment.apiUrls.imageUrl;
  enrolmentData
  user_id:any;
  student_id:any;
  currentUrl:any
  resultPassword:any
  @ViewChild('name') inputName;
  user_role:any
  activeTab:any

  guideline_data:any
  emp_List =[]
  selected_emp_referral = null
  row_id:any

  referral_model ={
    refrence: '',
    report_to: '',
    notes: '',
    admin_notes: '',
  }
  emp_list =[]
  row_name :any
  user_idd:any
  form_data = new FormData()
  isRefral:any= true
  pageNumberSubscription : Subscription
  pageNo
  selected_trainging_tags: any = []
  training_tags_list = null
  onboarding_data: any;

  constructor(private apiService:ApiService,
              private modalService: NgbModal,
              public toastr: ToastrService,
              private spinner: NgxSpinnerService,
              private activatedRoute:ActivatedRoute,private route: Router,
              private store: Store<AppState>
             ) {
    this.currentUrl=this.activatedRoute.snapshot.routeConfig.path
    this.user_role=JSON.parse(localStorage.getItem('user'))
    if(this.currentUrl === 'allUsers-list'){
      let setting_data = JSON.parse(localStorage.getItem('setting-record'))
      let key_data = setting_data.filter((item) => item.key == 'Users') 
      this.guideline_data = key_data[0]?._id

      this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params['status'];
        this.pageNo = +params['page'];
        if(this.pageNo>0){
          this.setPage(this.pageNo);
        }
        else this.page.pageNumber = this.pageNo?this.pageNo-1:0
      })
      this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
      .subscribe(pageNumber => {
        this.page.pageNumber = pageNumber;
        if(pageNumber !==undefined){
          this.page.pageNumber = pageNumber ?  pageNumber-1 :0
        }
      });
      if(this.activeTab) this.activeStatusTab(this.activeTab,this.pageNo?this.pageNo:1)
      if(!this.activeTab) this.activeStatusTab('employee',this.pageNo?this.pageNo:1)

     }
    if( this.currentUrl === 'students-list'){
      let setting_data = JSON.parse(localStorage.getItem('setting-record'))
      let key_data = setting_data.filter((item) => item.key == 'Students') 
      this.guideline_data = key_data[0]?._id

      this.activatedRoute.queryParamMap.subscribe((params) => {
        let page = +params.get('page');
        this.setPage(page)
      });
      this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
      .subscribe(pageNumber => {
        this.page.pageNumber = pageNumber;
        if(pageNumber !==undefined){
          this.page.pageNumber = pageNumber -1
        }
        if(pageNumber === 0) this.page.pageNumber = 0
        
      });

    }
    
  
  }
  ngOnInit(): void {
    if(this.currentUrl === 'allUsers-list'){
      this.setAndGetUsersByStatus();
    }
    if( this.currentUrl === 'students-list'){
      this.getAllStudents()
      this.getEmployeeStatusList()
      this.getFullAndPartTimeEmp()
    }
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
  activeStatusTab(tab,page) {
    if(page<1){ page =1}
    const activetab = tab;
    if (activetab !== '') {
      this.route.navigate(
        [],
        { relativeTo: this.activatedRoute, queryParams: { status: activetab ,  page : page },queryParamsHandling: 'merge' }
      );
    }
  }
  setAndGetUsersByStatus() {
    this.activatedRoute.queryParams
      .subscribe((params: any) => {
        this.activeTab = params?.status;
        switch (this.activeTab) {
          case 'employee':
            this.getUsersByStatus(this.activeTab);
            break;
          case 'student':
            this.getUsersByStatus(this.activeTab);
            break;
        }
      })
  }
  clearFilter(){
    if(this.currentUrl == 'allUsers-list'){
    this.setAndGetUsersByStatus()
    }
    else if( this.currentUrl == 'students-list'){
      this.searchByName=null
      this.getAllStudents()
    }
  }
getFilterUser(data:any){
  this.searchByName=data
    this.apiService.getUsersSearch(this.searchByName).subscribe((res:any)=>{
      this.rows=res?.data
      this.page.totalPages=res?.data.length
    })
}
resetFilter(){
  if(this.currentUrl == 'allUsers-list'){
    this.inputName.nativeElement.value = null;
    this.setAndGetUsersByStatus()
  }
  else if(this.currentUrl == 'students-list'){
    this.inputName.nativeElement.value = null;
    this.getAllStudents()
  }
}
getAllUsers(){
  this.spinner.show(undefined,
    {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
  this.apiService.getAllUsers(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
   this.spinner.hide();
   if(res.statusCode === 200){
    this.rows =res.data.items  
    this.page.totalPages=res.data.totalCount
   }
   else{
    this.toastr.error(res.error)
   }
  })
}
getUsersByStatus(status){
  this.spinner.show(undefined,
    {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
  this.apiService.getAllUsersByStatus(this.page.pageNumber+1,this.limitRef,status).subscribe((res:any)=>{
   this.spinner.hide();
   if(res.statusCode === 200){
    this.rows =res.data.items  
    this.page.totalPages=res.data.totalCount
   }
   else{
    this.toastr.error(res.error)
   }
    
  })
}
getAllStudents(){
  this.spinner.show(undefined,
    {
      type: 'ball-triangle-path',
      size: 'medium',
      bdColor: 'rgba(0, 0, 0, 0.8)',
      color: '#fff',
      fullScreen: true
    });
  this.apiService.getAllStudents(this.page.pageNumber+1,this.limitRef).subscribe((res:any)=>{
    this.spinner.hide();
    if(res.statusCode=== 200){
      this.rows =res?.items  
      this.page.totalPages=res.total
    }
    else{
      this.toastr.error(res.error)
    }
    
  })
}
getFilterStudent(data:any){ 
  this.searchByName = data 
  this.apiService.getStudentBySearch(this.page.pageNumber+1,100,this.searchByName).subscribe((res:any)=>{
    if(res.statusCode === 200){
      this.rows =res?.items
      this.page.totalPages=res.total
    }
    else{
      this.toastr.error(res.error)
    }
  })
}
getRoles(){
  this.apiService.getRoles().subscribe((res:any)=>{
    this.roles=res.data
  })
}
getRoleId(event:any){
  this.selectedValue=event.target.value
 let role= this.roles.filter((role)=> role._id ===this.selectedValue)
}

  pageChangeData(page:any) {
    this.route.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { page: page.offset +1 },
      queryParamsHandling: 'merge' // keep existing query params
    });
    if(this.currentUrl ==='allUsers-list'){
      this.apiService.getAllUsersByStatus(page.offset +1,this.limitRef,this.activeTab).subscribe((res:any)=>{
        this.setPage(page.offset +1)
        this.rows =res.data.items  
        this.page.totalPages=res.data.totalCount
      })
    }
    if(this.currentUrl ==='students-list'){
      this.apiService.getAllStudents(page.offset +1,this.limitRef).subscribe((res:any)=>{
        this.setPage(page.offset +1)
        this.rows =res.items   
        this.page.totalPages=res.total
      })
    } 
  }
  
  deleteUser(id,password){
    if(id){
      this.apiService.deleteUser(id,password).subscribe((res:any)=>{
        if(res.isSuccess === true){
          this.setAndGetUsersByStatus()
          swal.fire({
            title: 'Success',
            text: 'User deleted successfully !',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })   
        }
        else{
          swal.fire({
            title: 'Cancelled',
            text: `${res.error}`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        } 
        })
        
  
    }
      
  }
  deleteStudent(password){
    
    if(this.student_id){
      this.apiService.deleteStudent(this.student_id,password).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.getAllStudents()
          swal.fire({
            title: 'Success',
            text: 'Student deleted successfully !',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })        }
        else{
          swal.fire({
            title: 'Cancelled',
            text: `${res.error}`,
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success'
            },
          })
        } 
        })
    }
      else{
        this.toastr.error('Something went wrong !')
      }

  }

  // ================== Delete Alert ========================
   ConfirmColor(id:any) {
    if(this.currentUrl == 'students-list'){
      this.student_id=id  
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then( (result)=> {
      if (result.value) {  
        if(this.currentUrl == 'students-list'){
          this.deleteStudent(result.value)
        }
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
  else if(this.currentUrl == 'allUsers-list'){
     this.user_id=id
     swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteUser(this.user_id,result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
}

  setDefaultPassword(id:any,name:string){
    this.userId=id
    if(this.userId){
      this.apiService.changePasswordEnrolment(this.userId).subscribe((res:any)=>{
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
          swal.fire({
            title: "Success!",
            text: `${name} your password is combination of name's first 4 letters (capital) and phone number's last 4 digits`,
            icon: "success",
            customClass: {
              confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false,
          });
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }    
  }
  copyToClipboard(name:any,phone:any) {
    let n= name.substring(0,4).toUpperCase();
    let p=phone.substring(6)
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value =n+p
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('Password copied')
  }

  setNewPassowrd(newPassword){
    if(this.userId){
      let body={
        newPassword:newPassword
      }
      this.apiService.changePassword(this.userId,body).subscribe((res:any)=>{
        if (res.isSuccess === true) {
          this.toastr.success(res.message)
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }    
  }
  changePassword(id:any){
    this.userId=id
    swal.fire({
      text: "Set New Password",
      input: 'text',
      showCancelButton: true,
    }).then( (result)=> {
      if (result.value) {  
        if(id ){
          this.setNewPassowrd(result.value)
        }    
      } 
      else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  
  // ==========================================
 

    activateStudent(data){

        var id=data.id
        this.isActivated=data.is_activated=!data.is_activated
      
        let model={
          is_activated:this.isActivated
        }
        this.apiService.updateStudent(id,model).subscribe((res: any) => {
          if (res.isSuccess === true) {
            this.toastr.success(res.message)
            this.getAllStudents()
          }
          else{
            this.toastr.error(res.error)
          }
        }) 
      

}

openDynamicModal(key_id:string) {
  const modalOptions: NgbModalOptions = {
    size: 'lg', // 'sm', 'lg', or 'xl'
    backdrop: 'static',
  };
  const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
  modalRef.componentInstance.key_id = key_id;
}
// --- Referral --------------------------
getEmployeeStatusList() {
  this.apiService.getLeadsStatusList("employeestatus").subscribe((res: any) => {
    var status = res?.data?.filter(item => item?.name === 'full_time')
    const status_id = status[0]._id
    this.getFullTimeEmpList(status_id)
  })
}
getFullTimeEmpList(id){
  this.apiService.getEmployeeListByStatus(id,1,100).subscribe((res:any)=>{
    this.emp_List = res?.items
  })
}
selectEmpReferralId(event){
  this.selected_emp_referral
}
openReferralModal(content,id,referralBy) {
  this.row_id = id
  if(referralBy){
    this.selected_emp_referral = referralBy
  }
 
  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  const modalRef = this.modalService.open(content,options);
  modalRef.result.then((result) => {
    this.selected_emp_referral = null
    this.row_id = null
  }, (reason) => {
    this.selected_emp_referral = null
    this.row_id = null
  });
}
referralUpdate(){
  let body={
    refrenceid : this.selected_emp_referral
  }
  this.apiService.updateStudent(this.row_id,body).subscribe((res:any)=>{
    if(res?.statusCode === 200){
      this.toastr.success('Referral updated successfull!')
      this.modalService.dismissAll()
      this.getAllStudents()
    }
    else this.toastr.error(res?.error)
  })
}
getFullAndPartTimeEmp(){
  this.apiService.getFullPartEmployeeList(1,100).subscribe((res:any)=>{
    this.emp_list = res?.items
  })
}
getEmpId(event){
  this.referral_model.report_to 
}
openModalForReferral(content,userId,name) {
  this.row_name = name
  this.referral_model.refrence = `${this.user_role.id}`
  this.user_idd = userId   

  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  
  const modalRef = this.modalService.open(content,options);

  modalRef.result.then((result) => {
    this.referral_model.report_to = null
    this.referral_model.refrence = null
    this.user_idd = null
    this.form_data = new FormData()
  }, (reason) => {
    this.referral_model.report_to = null
    this.referral_model.refrence = null
    this.user_idd = null
    this.form_data = new FormData()
  });
 
}
addReferral(){
  this.form_data.append('ref_status','referal')
  this.form_data.append('report_to',this.referral_model?.report_to )
  this.form_data.append('notes',this.referral_model?.notes)
  this.form_data.append('admin_notes',this.referral_model?.admin_notes)
  this.form_data.append('is_refral',this.isRefral)
  this.form_data.append('refrence_by',this.user_role.id)
 
  this.apiService.updateUser(this.user_idd ,this.form_data).subscribe((res:any)=>{
    if(res?.statusCode === 200){
      this.toastr.success(res?.message)
      this.modalService.dismissAll()
      this.getAllStudents()
    }
    else this.toastr.error(res?.error)
  })
  }
  openTraingTagsModal(content, data) {
    this.getAllTraingingTags()
    this.row_id = data.id
      if (data.student_tag) {
      this.selected_trainging_tags = data.student_tag._id
    }
 
  const options: NgbModalOptions = {
    size: 'md', // set the size of the modal
    backdrop: 'static', // set whether clicking outside the modal closes it
    centered: true // set whether the modal is centered vertically
  };
  const modalRef = this.modalService.open(content,options);
  modalRef.result.then((result) => {
    this.selected_trainging_tags = null
    this.row_id = null
  }, (reason) => {
    this.selected_trainging_tags = null
    this.row_id = null
  });
  }
  getAllTraingingTags(){
    this.apiService.getTagByTagCatgoryId("667e7204c75e843bb234c08c").subscribe((res: any) => {
      this.training_tags_list = res?.data
    })
  }
  selectTraingingTagsId(event) {
    this.selected_trainging_tags
  }
  trainingTagsUpdate() {
    let body={
    student_tag : this.selected_trainging_tags
  }
  this.apiService.updateStudent(this.row_id,body).subscribe((res:any)=>{
    if(res?.statusCode === 200){
      this.toastr.success('Training tags updated successfull!')
      this.modalService.dismissAll()
      this.getAllStudents()
    }
    else this.toastr.error(res?.error)
  })
  }
  openModalForOnboarding(content,data){
    this.row_id = data
    this.onBoardingByStudent(this.row_id)
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content,options);
  
    modalRef.result.then((result) => {
      this.row_id = null
    }, (reason) => {
      this.row_id = null
    });
  }
  onBoardingByStudent(id){
    this.apiService.getAllOnboardingByStudent(id).subscribe((res:any)=>{
      this.onboarding_data= res?.data[0]
    })
  }
}
